import axios from "axios";

// Declare the URL for the backend server.
const baseURL = "https://apim-np-d-idb-integration.iadb.org/ext/slo/api";

const authService = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "ocp-apim-subscription-key": "8e05f19b1ceb4a8cb4ae4c624a383cdf",
  },
});


/**
 *
 * @param {string} country Country being requested
 * @returns JSON with country's geojson
 */
export const getGeoJSON = async (country) => {
  return fetch("/./geoJSONs/" + country + ".geojson", {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "Secure",
    },
  })
    .then((geojson) => geojson.json())
    .catch((error) => {
      console.log("Error retreiving GeoJSON for " + country);
      console.log(error);
    });
};

/**
 *
 * @param {string} type Type of wordcloud being requested
 * @returns JSON with wordcloud data
 */
export const getWordcloud = async (type) => {
  try {
    if (type !== "facebook" && type !== "twitter")
      throw Error("Wordcloud JSON not found for type: " + type);

    return fetch("/./communitiesJSONs/" + type + "Wordcloud.json", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "Secure",
      },
    })
      .then((wordcloud) => wordcloud.json())
      .catch((error) => {
        console.log("Error retreiving Wordcloud JSON for " + type);
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
};

/**
 *
 * @param {string} type Type of community being requested
 * @returns JSON with community data
 */
export const getCommunities = async (type) => {
  try {
    if (type !== "facebook")
      throw Error("JSON for communities not found for type: " + type);

    return fetch("/./communitiesJSONs/" + type + "Groups.json", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "Secure",
      },
    })
      .then((communities) => communities.json())
      .catch((error) => {
        console.log("Error retreiving Communities JSON for " + type);
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
};

/**
 *
 * @param {string} country Country being requested
 * @returns Array Buffer with report data
 */
export const getReport = async (country, language) =>
  await authService.get(`/reports/${country}/${language}`);

/**
 *
 * @param {string} type Type of json being requested
 * @returns JSON with survey data
 */
export const getSurveyJSON = (type) => {
  try {
    return fetch("/./surveyJSONs/" + type + ".json", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "Secure",
      },
    })
      .then((data) => data.json())
      .catch((error) => {
        console.log("Error retreiving Survey Card JSON for " + type);
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
};